export const sidebarConfig = {
  superadmin: [
    'UserManagement',
    'ChangePassword',
    // 'CustomerManagement',
    // 'AddDevice',
    // 'DeviceLocation',
    // 'AppVersion'
    'AddPart',
    'SaleModel',
    'Delevery',
    'DispatchNo',
    'CreateDc',
    'DispatchNoOrderList',
    'MasterList',
    'DispatchSupervisorResult',
    'StockListResult',
    'AttendenceTab',
    'FacultyTab',
    'StudentTab',
    'StudentUserList',
    'DeviceManagement',
    'StudentSms',
    'BdaSemDashboard',
    'StudentAddDevice',
    'FacultyDepartmentList',
    'HistoryTab',
    'StudentReportTab',
    'StdSemTransfer',
    'LAttendanceTab',
  ],
  systemspecialist: [
    // 'Dashboard',
    'CustomerManagement',
    'UserManagement',
    'ChangePassword',
    'Vendor',
    // 'Location',
    // 'Report',
    // 'Device',
    // 'AddDevice',
    // 'DeviceLocation',
    // 'EmailConfig',
  ],
  admin: [
    'Dashboard',
    'ChangePassword',
    'CustomerManagement',
    'UserManagement',
    'MasterList',
    'DispatchSupervisorResult',
    'StockListResult',
    'AttendenceTab',
    // 'FacultyTab',
    'StudentTab',
    'StudentUserList',
    'StudentSms',
    'BdaSemDashboard',
    'StudentAddDevice',
    // 'FacultyDepartmentList',
    'HistoryTab',
    'StudentReportTab',
    'SMSWalletModule',
    'StdSemTransfer',
    'StdSemTransferTab',
    // 'LAttendanceTab',
    // 'AttendenceModification',
  ],
  hod: [
    // 'Dashboardhod',
    'Dashboard',
    'ChangePassword',
    'CustomerManagement',
    'UserManagement',
    'MasterList',
    'DispatchSupervisorResult',
    'StockListResult',
    'AttendenceTab',
    // 'FacultyTab',y
    'StudentTab',
    // 'StudentUserList',
    // 'StudentSms',
    'BdaSemDashboard',
    'StudentAddDevice',
    // 'FacultyDepartmentList',
    'HistoryTab',
    'StudentReportTab',
    'StdSemTransfer',
    'StdSemTransferTab',
    // 'LAttendanceTab',
    // 'AttendenceModification',
  ],
  faculty: [
    'Dashboard',
    // 'ChangePassword',
    // 'CustomerManagement',
    // 'UserManagement',
    // 'MasterList',
    // 'DispatchSupervisorResult',
    // 'StockListResult',
    'AttendenceTabFaculty',
    // 'FacultyTab',
    // 'StudentTab',
    // 'StudentUserList',
    // 'StudentSms',
    // 'BdaSemDashboard',
    // 'StudentAddDevice',
    // 'FacultyDepartmentList',
    // 'HistoryTab',
    'StudentReportTabFaculty',
    // 'StdSemTransfer',
    // 'StdSemTransferTab',
  ],
  principal: [
    'Dashboard',
    'ChangePassword',
    'CustomerManagement',
    'UserManagement',
    'MasterList',
    'DispatchSupervisorResult',
    'StockListResult',
    'AttendenceTab',
    'FacultyTab',
    'StudentTab',
    'StudentUserList',
    'StudentSms',
    'BdaSemDashboard',
    'StudentAddDevice',
    'FacultyDepartmentList',
    'HistoryTab',
    'StudentReportTab',
    'StdSemTransfer',
    'StdSemTransferTab',
    'LAttendanceTab',
  ],
  user: [
    'Dashboard',
    // 'ChangePassword',
    // 'CustomerManagement',
    // 'UserManagement',
    // 'Vendor',
    // 'AddPart',
    'SaleModel',
    'Delevery',
    'DispatchNo',
    // 'CreateDc',
    'DispatchNoOrderList',
    // 'MasterList',
    // 'DispatchSupervisorResult',
    'StockListResult',
    // 'InvoiceResult',
    // 'AllReportList',
  ],
  mgmt: [
    'Dashboard',
  ],
  crm: [
    'InvoiceResult',
    'AllReportList',
  ],
  purchase: [
    'Delevery',
  ],
  invoice: [
    'InvoiceResult',
    'AllReportList',
  ],
  dispatch: [
    // 'Dashboard',
    'DispatchNo',
    'DispatchNoOrderList',
    'DispatchSupervisorResult',
  ],
  dispatchSupervisor: [
    'DispatchNo',
    'DispatchNoOrderList',
    'DispatchSupervisorResult',
  ],
};
// 'GasCylinder'
export const crudConfig = {
  dashboard: {
    superadmin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: false,
      edit: true,
      delete: true,
    },
    manager: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    user: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    Purchaseer: {
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    Invoice: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
    Dispatch: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
    DispatchSupervisor: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
  },
  location: {
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: false,
      edit: true,
      delete: false,
    },
    manager: {
      view: true,
      add: false,
      edit: true,
      delete: false,
    },
    user: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
    Dispatch: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
    DispatchSupervisor: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
  },
  emailconfig: {
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: false,
      edit: true,
      delete: false,
    },
    manager: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
    user: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
  },
  usermanagement: {
    superadmin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    manager: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    user: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  vendor: {
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    manager: {
      view: true,
      add: true,
      edit: true,
      delete: false,
    },
    user: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  gascylinder: {
    superadmin: {
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    manager: {
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    user: {
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
  },
  changepassword: {
    superadmin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    manager: {
      view: true,
      add: true,
      edit: true,
      delete: false,
    },
    user: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
  },
  device: {
    superadmin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: false,
      edit: true,
      delete: true,
    },
    manager: {
      view: true,
      add: false,
      edit: true,
      delete: false,
    },
    user: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
  },
  report: {
    superadmin: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
    },
    admin: {
      view: true,
      add: false,
      edit: true,
      delete: true,
    },
    manager: {
      view: true,
      add: true,
      edit: true,
      delete: false,
    },
    user: {
      view: true,
      add: false,
      edit: false,
      delete: false,
    },
  },
  devicelocation: {
    systemspecialist: {
      view: true,
      add: true,
      edit: true,
      delete: true,
      changeDeviceMode: {
        view: true,
        add: true,
        edit: true,
        delete: true,
      },
    },
    admin: {
      view: true,
      add: false,
      edit: true,
      delete: false,
      changeDeviceMode: {
        view: true,
        add: false,
        edit: true,
        delete: false,
      },
    },
    manager: {
      view: true,
      add: false,
      edit: true,
      delete: false,
      changeDeviceMode: {
        view: false,
        add: false,
        edit: true,
        delete: false,
      },
    },
    user: {
      view: true,
      add: false,
      edit: false,
      delete: false,
      changeDeviceMode: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
    },
  },
};
